import HttpClient from '../services/HttpClient';
import { APP_URL, ROLE, MODULE, FUNCTIONALITY, ASSIGNMENT_ROLES, ROLESTATUS, ROLEBYSTATUS } from  '../constants';

export const getAllRoles = () => {
    return new Promise((resolve, reject) => {
        const headers = {
            'Content-Type': 'application/json'
        };
        HttpClient.get(`${APP_URL}${ROLE}`, headers).then(response => {
            if (response.data.result) {
                resolve(response);
            }
            resolve(response);
        }).catch(error => {
            if (typeof error.response === 'undefined') {

                reject({ error: 'technical_error', error_description: 'Ocurrió un problema, comuníquese con el administrador' });
            }
            reject(error.response);
            resolve(error.response);
        });
    });
}
export const getAllRoleById = (roleId) => {
    return new Promise((resolve, reject) => {
        const headers = {
            'Content-Type': 'application/json'
        };
        HttpClient.get(`${APP_URL}${ROLE}role-module/${roleId}`, headers).then(response => {
            if (response.data.result) {
                resolve(response);
            }
            resolve(response);
        }).catch(error => {
            if (typeof error.response === 'undefined') {

                reject({ error: 'technical_error', error_description: 'Ocurrió un problema, comuníquese con el administrador' });
            }
            reject(error.response);
            resolve(error.response);
        });
    });
}

export const createRole = (body, dispatch) => {
    return new Promise((resolve, reject) => {
        const headers = {
            'Content-Type': 'application/json'
        };
        HttpClient.post(`${APP_URL}${ROLE}`, body, headers).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
}

export const updateRoleModules = (body, dispatch) => {
    return new Promise((resolve, reject) => {
        const headers = {
            'Content-Type': 'application/json'
        };
        HttpClient.put(`${APP_URL}${ROLE}${ASSIGNMENT_ROLES}`, body, headers).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
}

export const getModules = () => {
    return new Promise((resolve, reject) => {
        const headers = {
            'Content-Type': 'application/json'
        };
        HttpClient.get(`${APP_URL}${MODULE}/`, headers).then(response => {
            if (response.data.result) {
                resolve(response);
            }
            resolve(response);
        }).catch(error => {
            if (typeof error.response === 'undefined') {

                reject({ error: 'technical_error', error_description: 'Ocurrió un problema, comuníquese con el administrador' });
            }
            reject(error.response);
            resolve(error.response);
        });
    });
}

export const getFunctionality = () => {
    return new Promise((resolve, reject) => {
        const headers = {
            'Content-Type': 'application/json'
        };
        HttpClient.get(`${APP_URL}${MODULE}${FUNCTIONALITY}`, headers).then(response => {
            if (response.data.result) {
                resolve(response);
            }
            resolve(response);
        }).catch(error => {
            if (typeof error.response === 'undefined') {

                reject({ error: 'technical_error', error_description: 'Ocurrió un problema, comuníquese con el administrador' });
            }
            reject(error.response);
            resolve(error.response);
        });
    });
}

export const updateStatusRol = (body) => {
    return new Promise((resolve, reject) => {
        const headers = {
            'Content-Type' : 'application/json'
        };
        HttpClient.put(`${APP_URL}${ROLESTATUS}`, body, headers).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response)
        })
    })
}

export const getAllRoleByStatus = (status) => {
    return new Promise((resolve, reject) => {
        const headers = {
            'Content-Type': 'application/json'
        };
        HttpClient.get(`${APP_URL}${ROLEBYSTATUS}${status}`, headers).then(response => {
            if (response.data.result) {
                resolve(response);
            }
            resolve(response);
        }).catch(error => {
            if (typeof error.response === 'undefined') {

                reject({ error: 'technical_error', error_description: 'Ocurrió un problema, comuníquese con el administrador' });
            }
            reject(error.response);
            resolve(error.response);
        });
    });
}
